module.exports = __webpack_public_path__ + "img/Logo-10.d13cf51f.svg";